import DestinationPage from "@/components/DestinationPage";
const related = [
  { name: "Grecia", slug: "grecia", image: "https://images.unsplash.com/photo-1506242592132-b7476b527d50?w=600&q=80" },
  { name: "Muntenegru", slug: "muntenegru", image: "https://images.unsplash.com/photo-1689517686262-628708bbc5d7?w=600&q=80" },
  { name: "Turcia", slug: "turcia", image: "https://images.unsplash.com/photo-1774850691859-0e339f94bebb?w=600&q=80" },
];
export default function SpaniaPage() {
  return (
    <DestinationPage
      name="Spania" nameRo="Spania" slug="spania" flag="🇪🇸"
      heroImage="https://images.unsplash.com/photo-1758471206484-0eaa2568320c?w=1920&q=80"
      metaTitle="Vacanță în Spania din Chișinău | Barcelona, Costa del Sol, Tenerife – Premium Style Travel"
      metaDescription="Oferte vacanță Spania din Chișinău. Barcelona, Costa del Sol, Tenerife, Mallorca. Zbor + hotel. Pachete 2025-2026. Sună +373 60609292."
      tagline="Barcelona, tapas, flamenco și plajele însorite ale Costa del Sol — Spania are ceva pentru fiecare."
      description="Spania este una dintre cele mai diverse destinații turistice din Europa, oferind o varietate uimitoare de experiențe. Barcelona fascinează cu arhitectura lui Gaudí (Sagrada Família, Parcul Güell), viața de noapte vibrantă și bucătăria catalană. Costa del Sol și Costa Brava oferă plaje magnifice cu soare aproape tot anul. Insulele Canare — Tenerife și Gran Canaria — sunt destinații ideale pentru iarnă, cu temperaturi de 22-25°C. Mallorca și Ibiza completează oferta cu peisaje mediteranene și petreceri legendare."
      highlights={[
        "Barcelona – Sagrada Família și arhitectura Gaudí",
        "Costa del Sol – plajele din Malaga și Marbella",
        "Tenerife – vulcanul Teide și plajele de nisip negru",
        "Madrid – Muzeul Prado și viața culturală",
        "Sevilla – Catedrala, Alcázar și flamenco autentic",
        "Mallorca – golfuri ascunse și stânci spectaculare",
        "Granada – Alhambra, minune arhitecturală arabă",
        "Bucătăria spaniolă – paella, tapas, sangria",
      ]}
      included={[
        "✈️ Zbor dus-întors din Chișinău",
        "🏨 Cazare hotel 3★–5★ în locație centrală",
        "🚌 Transfer aeroport – hotel – aeroport",
        "🛡️ Asigurare medicală de călătorie",
        "📋 Taxe și comisioane incluse",
      ]}
      faqs={[
        { q: "Este nevoie de viză pentru Spania?", a: "Spania face parte din spațiul Schengen. Cetățenii moldoveni cu pașaport biometric pot intra fără viză pentru sejururi de până la 90 de zile." },
        { q: "Când este cel mai bun sezon pentru Spania?", a: "Mai–octombrie pentru plaje. Insulele Canare sunt ideale iarna (nov–apr). Barcelona și Madrid sunt frumoase tot anul." },
        { q: "Cât durează zborul din Chișinău?", a: "Aproximativ 3-4 ore spre Barcelona sau Madrid, de obicei cu o escală scurtă." },
        { q: "Ce este mai bine – Barcelona sau Costa del Sol?", a: "Depinde de preferințe. Barcelona este ideală pentru cultură și city-break. Costa del Sol pentru relaxare la plajă. Le puteți combina!" },
        { q: "Spania este scumpă?", a: "Spania are destinații pentru toate bugetele. Barcelona și Ibiza sunt mai scumpe, Costa del Sol și insulele Canare sunt accesibile." },
      ]}
      relatedDestinations={related}
    />
  );
}
